import { ChangeDetectionStrategy, Component } from "@angular/core";
import { EntityIdType } from "@front/m19-api-client";
import { ActivityComponent } from "@m19-board/activities/activity/activity.component";

@Component({
  selector: "app-activities-component",
  template: "<app-activity-component [activityFilter]='ActivityFilter'></app-activity-component>",
  imports: [ActivityComponent],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ActivitiesComponent {
  ActivityFilter = [
    {
      primaryType: EntityIdType.strategyId,
    },
    {
      primaryType: EntityIdType.creativeId,
    },
    {
      primaryType: EntityIdType.segmentId,
    },
    {
      primaryType: EntityIdType.strategyGroupId,
    },
    {
      primaryType: EntityIdType.audienceTargetId,
    },
    {
      primaryType: EntityIdType.profileId,
    },
  ];
}
